import { useEffect } from "react";

interface SeoProps {
  title: string;
  description: string;
  jsonLd?: object[];
}

export default function Seo({ title, description, jsonLd = [] }: SeoProps) {
  useEffect(() => {
    document.title = title;

    const upsertMeta = (attr: "name" | "property", key: string, content: string) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);

    // 注入 JSON-LD
    const existing = document.querySelectorAll("script[data-jsonld]");
    existing.forEach((n) => n.remove());
    if (jsonLd.length > 0) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-jsonld", "1");
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
  }, [title, description, jsonLd]);

  return null;
}